import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IAddKeyReq,IPatientRes} from './index.type';
// { patientId }: { patientId: string  }

const useSendKey = () => {
  const url = `/rtm/key`;
  const method = 'POST'; 
  const { loading: addKeyLoading , makeApiCall } = useApi({ url, method });

  const addKey = async (formData:  IAddKeyReq ) => {
    const { response, error } = await makeApiCall< IAddKeyReq , IPatientRes>(formData);
    if (response?.status === 'success') {
    //   toast.success(patientId ? 'Patient updated successfully' : 'Patient added successfully')
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to send key. Please check your connection and try again.');
      return { status: 'fail' };
    }
  };

  return {
    addKeyLoading,
    addKey,
  };
};

export default useSendKey;
